import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4d755ba1 = () => interopDefault(import('../pages/actions/index.vue' /* webpackChunkName: "pages/actions/index" */))
const _bf12c604 = () => interopDefault(import('../pages/brands/index.vue' /* webpackChunkName: "pages/brands/index" */))
const _89f599dc = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _5e273fbd = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _58734db9 = () => interopDefault(import('../pages/collections/index.vue' /* webpackChunkName: "pages/collections/index" */))
const _a83c21be = () => interopDefault(import('../pages/company/index.vue' /* webpackChunkName: "pages/company/index" */))
const _28ca8d89 = () => interopDefault(import('../pages/compare/index.vue' /* webpackChunkName: "pages/compare/index" */))
const _d8dff506 = () => interopDefault(import('../pages/delete-account/index.vue' /* webpackChunkName: "pages/delete-account/index" */))
const _202e89c8 = () => interopDefault(import('../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _5ca991f3 = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _43d7f9c0 = () => interopDefault(import('../pages/info/index.vue' /* webpackChunkName: "pages/info/index" */))
const _90216d66 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _98051188 = () => interopDefault(import('../pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _89a701f6 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _5743f21c = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _94119a9c = () => interopDefault(import('../pages/personal/index.vue' /* webpackChunkName: "pages/personal/index" */))
const _d3ef7e54 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _6abbf364 = () => interopDefault(import('../pages/stores/index.vue' /* webpackChunkName: "pages/stores/index" */))
const _cc388042 = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _57d4e5df = () => interopDefault(import('../pages/company/about/index.vue' /* webpackChunkName: "pages/company/about/index" */))
const _1d74ccd7 = () => interopDefault(import('../pages/company/contacts/index.vue' /* webpackChunkName: "pages/company/contacts/index" */))
const _8b4de9c4 = () => interopDefault(import('../pages/company/requisites/index.vue' /* webpackChunkName: "pages/company/requisites/index" */))
const _1dff464b = () => interopDefault(import('../pages/order/pay/index.vue' /* webpackChunkName: "pages/order/pay/index" */))
const _21d70a86 = () => interopDefault(import('../pages/order/pay-error/index.vue' /* webpackChunkName: "pages/order/pay-error/index" */))
const _1abd8974 = () => interopDefault(import('../pages/order/pay-ok/index.vue' /* webpackChunkName: "pages/order/pay-ok/index" */))
const _563ba430 = () => interopDefault(import('../pages/personal/bonuses/index.vue' /* webpackChunkName: "pages/personal/bonuses/index" */))
const _20223e78 = () => interopDefault(import('../pages/personal/orders/index.vue' /* webpackChunkName: "pages/personal/orders/index" */))
const _425379cc = () => interopDefault(import('../pages/personal/profile/index.vue' /* webpackChunkName: "pages/personal/profile/index" */))
const _6a6df1f0 = () => interopDefault(import('../pages/personal/orders/__id/index.vue' /* webpackChunkName: "pages/personal/orders/__id/index" */))
const _88528902 = () => interopDefault(import('../pages/actions/__id/index.vue' /* webpackChunkName: "pages/actions/__id/index" */))
const _a9ae677c = () => interopDefault(import('../pages/brands/__id/index.vue' /* webpackChunkName: "pages/brands/__id/index" */))
const _3d1f699a = () => interopDefault(import('../pages/catalog/__slug/index.vue' /* webpackChunkName: "pages/catalog/__slug/index" */))
const _aad86c92 = () => interopDefault(import('../pages/collections/__slug/index.vue' /* webpackChunkName: "pages/collections/__slug/index" */))
const _12e59f86 = () => interopDefault(import('../pages/help/__slug/index.vue' /* webpackChunkName: "pages/help/__slug/index" */))
const _dd72fb20 = () => interopDefault(import('../pages/info/__slug/index.vue' /* webpackChunkName: "pages/info/__slug/index" */))
const _a67bd2ca = () => interopDefault(import('../pages/news/__id/index.vue' /* webpackChunkName: "pages/news/__id/index" */))
const _1ebbcf6a = () => interopDefault(import('../pages/products/__id/index.vue' /* webpackChunkName: "pages/products/__id/index" */))
const _1a50f4c8 = () => interopDefault(import('../pages/stores/__id/index.vue' /* webpackChunkName: "pages/stores/__id/index" */))
const _514f7f33 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/actions",
    component: _4d755ba1,
    name: "actions"
  }, {
    path: "/brands",
    component: _bf12c604,
    name: "brands"
  }, {
    path: "/cart",
    component: _89f599dc,
    name: "cart"
  }, {
    path: "/catalog",
    component: _5e273fbd,
    name: "catalog"
  }, {
    path: "/collections",
    component: _58734db9,
    name: "collections"
  }, {
    path: "/company",
    component: _a83c21be,
    name: "company"
  }, {
    path: "/compare",
    component: _28ca8d89,
    name: "compare"
  }, {
    path: "/delete-account",
    component: _d8dff506,
    name: "delete-account"
  }, {
    path: "/favourites",
    component: _202e89c8,
    name: "favourites"
  }, {
    path: "/help",
    component: _5ca991f3,
    name: "help"
  }, {
    path: "/info",
    component: _43d7f9c0,
    name: "info"
  }, {
    path: "/login",
    component: _90216d66,
    name: "login"
  }, {
    path: "/logout",
    component: _98051188,
    name: "logout"
  }, {
    path: "/news",
    component: _89a701f6,
    name: "news"
  }, {
    path: "/order",
    component: _5743f21c,
    name: "order"
  }, {
    path: "/personal",
    component: _94119a9c,
    name: "personal"
  }, {
    path: "/products",
    component: _d3ef7e54,
    name: "products"
  }, {
    path: "/stores",
    component: _6abbf364,
    name: "stores"
  }, {
    path: "/video",
    component: _cc388042,
    name: "video"
  }, {
    path: "/company/about",
    component: _57d4e5df,
    name: "company-about"
  }, {
    path: "/company/contacts",
    component: _1d74ccd7,
    name: "company-contacts"
  }, {
    path: "/company/requisites",
    component: _8b4de9c4,
    name: "company-requisites"
  }, {
    path: "/order/pay",
    component: _1dff464b,
    name: "order-pay"
  }, {
    path: "/order/pay-error",
    component: _21d70a86,
    name: "order-pay-error"
  }, {
    path: "/order/pay-ok",
    component: _1abd8974,
    name: "order-pay-ok"
  }, {
    path: "/personal/bonuses",
    component: _563ba430,
    name: "personal-bonuses"
  }, {
    path: "/personal/orders",
    component: _20223e78,
    name: "personal-orders"
  }, {
    path: "/personal/profile",
    component: _425379cc,
    name: "personal-profile"
  }, {
    path: "/personal/orders/:_id",
    component: _6a6df1f0,
    name: "personal-orders-_id"
  }, {
    path: "/actions/:_id",
    component: _88528902,
    name: "actions-_id"
  }, {
    path: "/brands/:_id",
    component: _a9ae677c,
    name: "brands-_id"
  }, {
    path: "/catalog/:_slug",
    component: _3d1f699a,
    name: "catalog-_slug"
  }, {
    path: "/collections/:_slug",
    component: _aad86c92,
    name: "collections-_slug"
  }, {
    path: "/help/:_slug",
    component: _12e59f86,
    name: "help-_slug"
  }, {
    path: "/info/:_slug",
    component: _dd72fb20,
    name: "info-_slug"
  }, {
    path: "/news/:_id",
    component: _a67bd2ca,
    name: "news-_id"
  }, {
    path: "/products/:_id",
    component: _1ebbcf6a,
    name: "products-_id"
  }, {
    path: "/stores/:_id",
    component: _1a50f4c8,
    name: "stores-_id"
  }, {
    path: "/",
    component: _514f7f33,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
